export default __webpack_public_path__ + "static/O0226-48b3056807901ddbbac66553b8303d90.png";